import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import * as moment from "moment";
import JwtClient from "./JwtClient";
import Col from "react-bootstrap/Col";
import Alert from "./Alert";

export default class UPSMIEventForm extends React.Component {
    eventDateFormat = 'YYYY-MM-DD';

    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            isSubmitting: false,
            packageID: props.packageID,
            values: {
                event_date: '',
            },
            errors: {
                event_date: '',
            },
        };
    }

    render() {
        if (!!this.state.alert) {
            return <Alert>{this.state.alert}</Alert>
        }

        const {
            values,
            isSubmitting,
            errors,
        } = this.state;

        return (
            <div>
                <hr/>
                <Form onSubmit={this.handleSubmit}>

                    <Form.Row>
                        <Col md>
                            <Form.Group>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <small>Delivered date (NY)</small>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        name="event_date"
                                        value={values.event_date}
                                        onChange={this.handleChange}
                                        isInvalid={!!errors.event_date}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.event_date}</Form.Control.Feedback>
                                </InputGroup>
                                <Form.Text className="text-muted">
                                    Format: YYYY-MM-DD
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col className="text-right">
                            <Button type="submit" disabled={isSubmitting} className="btn-success">Add Event</Button>
                        </Col>
                    </Form.Row>
                </Form>
            </div>
        )
    }

    isValidForm = () => {
        const {
            values,
        } = this.state;
        let valid = true;

        if (values.event_date.length === 0) {
            this.setErrors({event_date: 'required'});
            valid = false;
        } else if (!moment(values.event_date, this.eventDateFormat, true).isValid()) {
            this.setErrors({event_date: 'invalid format'});
            valid = false;
        }

        return valid;
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setSubmitting(true);
        if (this.isValidForm()) {
            this.postEvent();
        } else {
            this.setState({alert: ''})
        }
        this.setSubmitting(false);
        this.clearValues();
    };

    postEvent = () => {
        const event = this.state.values;

        JwtClient.post(`/api/v1/admin/packages/${this.props.packageID}/upsmi-events`, {
            event_date: moment.tz(event.event_date, 'America/New_York').utc().format(),
            tracking_number: this.props.trackingNumber,
        })
            .then(response => {
                if (response.status === 201) {
                    this.setState({alert: 'Successfully added'});
                    const {code, description, date, created_at} = response.data;
                    this.props.addEvent(
                        {
                            'code': code,
                            'description': description,
                            'city': '',
                            'state': '',
                            'zip': '',
                            'date': date,
                            'created_at': created_at,
                        });
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.setState({alert: 'Unauthorized'})
                    }
                    this.setState({alert: 'Error on posting manifest event values, status: ' + error.response.status + ' Data: ' + JSON.stringify(error.response.data)});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
    };

    handleChange = (e) => {
        this.setErrors({[e.target.name]: ''});
        this.setValues({[e.target.name]: e.target.value});
    };

    setValues = (values) => {
        this.setState((prevState) => ({values: {...prevState.values, ...values}}));
    };

    clearValues = () => {
        this.setState({values: {description: '', zip: '', city: '', address: '', state: '', event_date: ''}});
    };

    setSubmitting = (isSubmitting) => {
        this.setState({isSubmitting: isSubmitting});
    };

    setErrors = (errors) => {
        this.setState((prevState) => ({errors: {...prevState.errors, ...errors}}));
    };
}
